<div class="login">
  <div class="login-wrapper">
    <form autocomplete="off" [formGroup]="form" (submit)="auth()">
      <div class="header-form">
        <div class="logo-box">
          <img src="assets/img/logo-mini.svg" class="logo" alt="">
        </div>
        <div class="header-form__caption">
          <div class="title">Регистрация</div>
          <div class="caption">Вернуться на страницу <a routerLink="/login">входа</a></div>
        </div>
      </div>
      <div class="field-list">
        <div class="field">
          <div class="caption">Номер карты</div>
          <div class="field-input">
            <ui-input type="text" placeholder="Номер карты" formControlName="numbercard"></ui-input>
          </div>
        </div>
        <div class="field">
          <div class="caption">Пин-код карты</div>
          <div class="field-input">
            <ui-input type="text" placeholder="Пин-код карты" formControlName="pincode"></ui-input>
          </div>
        </div>
        <div class="field">
          <div class="caption">Пароль</div>
          <div class="field-input">
            <ui-input-password placeholder="Пароль" formControlName="password"></ui-input-password>
          </div>
        </div>
        <div class="field">
          <div class="caption">Подтверждение пароля</div>
          <div class="field-input">
            <ui-input-password placeholder="Пароль" formControlName="passwordConfirm"></ui-input-password>
          </div>
        </div>
      </div>
      <button nz-button nzType="primary" [disabled]="processing" type="submit">Зарегистрироваться</button>
      <div class="error error-server" *ngIf="serverError">{{this.serverError}}</div>
    </form>
  </div>
</div>
